export const baseURL = "https://3.27.121.21:3001";
export const ServiceURL = "https://3.27.121.21:3031";
export const imgBaseURL =
  "https://election-logebucket.s3.ap-southeast-2.amazonaws.com/";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

export const OTP_REQUEST_SUCCESS = "OTP_REQUEST_SUCCESS";
export const OTP_REQUEST_FAILURE = "OTP_REQUEST_FAILURE";

export const GETALLELECTIONTYPE = "GETALLELECTIONTYPE";
export const CREATEELECTIONTYPE = "CREATEELECTIONTYPE";
export const UPDATEELECTIONTYPE = "UPDATEELECTIONTYPE";
export const DELETEELECTIONTYPE = "DELETEELECTIONTYPE";

export const GETINTRESTEDCANDIDATE = "GETINTRESTEDCANDIDATE";
export const CREATE_INTRESTED_CANDIDATE_REQUEST = "CREATE_INTRESTED_CANDIDATE_REQUEST ";
export const CREATE_INTRESTED_CANDIDATE_SUCCESS = "CREATE_INTRESTED_CANDIDATE_SUCCESS";
export const CREATE_INTRESTED_CANDIDATE_FAIL = "CREATE_INTRESTED_CANDIDATE_FAIL";
export const UPDATEINTRESTEDCANDIDATE = "UPDATEINTRESTEDCANDIDATE";
export const DELETEINTRESTEDCANDIDATE = "DELETEINTRESTEDCANDIDATE";
export const GETSUBSECTION = "GETSUBSECTION";
export const GETCANDIDATE = "GETCANDIDATE";

export const GETSHEDULEMEETING = "GETSHEDULEMEETING";
export const CREATESHEDULEMEETING = "CREATESHEDULEMEETING";
// Generic loading, success, error for elections (can be used alternatively)
